import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

export interface CommandCenterShellState {
    active: boolean;
    navigationVisible: boolean;
}

@Injectable({ providedIn: 'root' })
export class CommandCenterShellService {
    private readonly _state$ = new BehaviorSubject<CommandCenterShellState>({
        active: false,
        navigationVisible: true,
    });

    public readonly state$ = this._state$.asObservable();

    public get snapshot(): CommandCenterShellState {
        return this._state$.value;
    }

    public enterCommandCenter(): void {
        this._state$.next({
            active: true,
            navigationVisible: false,
        });
    }

    public leaveCommandCenter(): void {
        this._state$.next({
            active: false,
            navigationVisible: true,
        });
    }

    public showNavigation(): void {
        this.patchState({ navigationVisible: true });
    }

    public hideNavigation(): void {
        this.patchState({ navigationVisible: false });
    }

    public toggleNavigationVisibility(): void {
        this.patchState({
            navigationVisible: !this.snapshot.navigationVisible,
        });
    }

    private patchState(patch: Partial<CommandCenterShellState>): void {
        this._state$.next({
            ...this.snapshot,
            ...patch,
        });
    }
}
